import React from 'react'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'
import Tooltip from 'components_new/atoms/Tooltip'

import DataTooltipContent from 'components_new/molecules/DataTooltipContent'

interface DistributionBarProps {
  heading: string

  /** Shares in percent, summing to 100. */
  segments: { color: string; label: string; value: number }[]
  sx?: SxProps
}

/** Shares side by side in one bar, spelled out on hover. */
const DistributionBar = (props: DistributionBarProps) => {
  const { heading, segments, sx } = props

  return (
    <Tooltip
      title={
        <DataTooltipContent
          rows={segments.map((segment) => ({
            color: segment.color,
            label: segment.label,
            unit: '%',
            value: String(Math.round(segment.value))
          }))}
          title={heading}
        />
      }
      variant="data"
    >
      <Box
        sx={{
          borderRadius: 0.5,
          display: 'flex',
          height: 8,
          overflow: 'hidden',
          width: 96,
          ...sx
        }}
      >
        {segments.map((segment) => (
          <Box
            key={segment.label}
            sx={{ bgcolor: segment.color, width: `${segment.value}%` }}
          />
        ))}
      </Box>
    </Tooltip>
  )
}

export default DistributionBar
